import { render, staticRenderFns } from "./Site.component.html?vue&type=template&id=23ed589e&scoped=true&external"
import script from "./Site.component.ts?vue&type=script&lang=ts&external"
export * from "./Site.component.ts?vue&type=script&lang=ts&external"
import style0 from "./Site.component.scss?vue&type=style&index=0&id=23ed589e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ed589e",
  null
  
)

export default component.exports